/* global window, document */
import { useEffect } from 'react';

/**
 * Passing --vh custom property to root
 */
export const useVHProperty = () => {
    useEffect(() => {
        const setVHProperty = () => {
            if (typeof window === 'undefined' || typeof document === 'undefined') return;

            const vh = window.innerHeight * 0.01;

            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        setVHProperty();

        window.addEventListener('resize', setVHProperty);

        return () => {
            window.removeEventListener('resize', setVHProperty);
        };
    }, []);
};
